export const ruDefaultTranslations: Record<string, string> = {
  'menu': 'Меню',
  'back': 'Назад',

  'service_order': 'Сделать заказ:',

  'messages': 'Сообщения',
  'cart': 'Корзина',
  'settings': 'Настройки',

  'subtitles': 'Субтитры',
  'turn_off_subtitles': 'Выключить',
  'no_subtitles_available': 'Субтитры недоступны',
  'off': 'Выключить',

  'original': 'Смотреть перевод',
  'translated': 'Смотреть без перевода',
  'isTranslated': '*перевод',
  'download_update': 'Пожалуйста, подождите.<br/>Загрузка обновления…',
  'download_retry': 'Повтор',
  'download_cancel': 'Отмена',
  'download_available': 'Доступно обновление. Обновить сейчас?',
  'auth_sent': 'Отправлен запрос авторизации.\nПожалуйста, дождитесь подтверждения…',
  'auth_pending': 'Ожидание авторизации…',
  'auth_rejected': 'Отказано в авторизации',
  'request_confirmed': 'Запрос подтвержден. Запрос №',
  'order_confirmed': 'Заказ подтвержден. Заказ №',
  'confirmed': 'подтверждено',
  'internet_required': 'Требуется Интернет подключение',
  'required_field': 'Обязательное поле',

  'openexturl': 'Открыть URL в браузере?',

  'messages_send': 'Отпр.',
  'messages_no_messages': 'Нет сообщений',

  'bill_page': 'Просмотр счёта',
  'bill_total': 'Итого',
  'bill_requesting': 'Запрос счёта...',
  'bill_error': 'Данные недоступны',
  'bill_checkedout': 'Гость выселен',
  'bill_loginreq': 'Требуется авторизация',

  'feedback_sent': 'Ваша анкета отправлена. Благодарим за заполнение.',
  'feedback_invalidfeedback': 'Опрос не существует',
  'feedback_alreadyanswered': 'Анкета уже была заполнена. Спасибо.',
  'go_to_feedback': 'Перейти к заполнению',
  'feedback_dialog_desc':
    'Спасибо за то, что вы выбрали наш отель. Мы будем очень признательны, если вы ответите на несколько вопросов о качестве работы наших служб. Спасибо, что помогаете нам стать лучше!',

  'yes': 'да',
  'no': 'нет',
  'add': 'Добавить',
  'suggestions': 'Предложения',
  'edit': 'изменить',
  'delete': 'удалить',
  'approx_time': 'Примерное время ожидания',
  'product_is_unavailable_for_selected_time':
    'Один из товаров в вашем заказе не доступен на выбранное время <br /> Пожалуйста, измените заказ',
  'alert': 'Предупреждение',

  'toppings': 'топпинги',
  'options': 'опции',
  'summary': 'итог',
  'new': 'новые',
  'not_placed': 'Не отправленные заказы',
  'placed': 'Отправленные заказы',
  'completed': 'выполненные',
  'in_process': 'В процессе',
  'cancelled': 'отмененные',
  'details': 'Подробнее',
  'order_details': 'Информация о заказе',
  'cancel_order': 'Отменить Заказ',
  'repeat_order': 'Повторить Заказ',
  'create_order': 'Размещение заказа',

  'cancellation_order': 'Отмена заказа',
  'order_was_cancelled': 'Заказ отменен',

  'order_already_exists': 'Похожий заказ уже существует',

  'number_of_persons': 'Количество человек',
  'number_of_cutlery': 'Количество приборов',
  'pieces_pcs': 'шт',
  'pieces_pers': 'чел',
  'pieces_h': 'ч',

  'select_none': 'Нет',
  'newmessage': 'Новые сообщения',
  'you_have_newmessage': 'У вас новые сообщения',

  'shop_add_comment': 'Добавить комментарий к заказу',
  'choose_options': 'Выбрать опции',
  'choose_airport': 'Выберите аэропорт',
  'departures': 'Отправление',
  'arrivals': 'Прибытие',
  'time': 'Время',
  'flight': 'Рейс',
  'destination': 'Место назначения',
  'gate': 'Ворота',
  'status': 'Статус',
  'from': 'Откуда',
  'terminal': 'Терминал',
  'change_airport': 'Сменить аэропорт',

  'scheduled': 'По расписанию',
  'delayed': 'Задержан',
  'diverted': 'Перенаправлен',
  'canceled': 'Отменен',
  'landed': 'Прибыл',
  'departed': 'Отправлен',

  'tv_television': 'Телевидение',
  'tv_nottelevision': 'Информация',
  'tv_room': 'Комната №',
  'tv_welcome': 'Добро пожаловать, ',
  'tv_allchannels': 'Все каналы',
  'tv_categories': 'Категории',
  'tv_category': 'Категория',
  'tv_back': 'Назад',

  'vod_title': 'Видео по запросу',
  'vod_purchases': 'Мои покупки',
  'vod_watch_question': 'Продолжить просмотр?',
  'vod_watch_continue': 'Продолжить',
  'vod_watch_start': 'Начать сначала',

  'pincode_remember':
    'Пожалуйста, запомните этот PIN. Он потребуется для подтверждения действий.<br>Для сброса PIN обратитесь на ресепшен.',

  'parental_lock': 'Родительский контроль',
  'parental_lock_enabled': 'Включено',
  'parental_lock_description': 'Подтверждать каждое действие вводом PIN',
  'parental_lock_confirm': 'Введите PIN',
  'parental_lock_disable_confirm': 'Для отключения Родительского контроля введите текущий PIN',
  'confirm': 'Подтвердить',

  'tv_channels': 'ТВ каналы',
  'anything_category': 'Любая категория',
  'anything_language': 'Любой язык',
  'category_channel': 'Категория телеканала:',
  'language_channel': 'Язык телеканала:',
  'navigation': 'Навигация',
  'choose_category': 'Выбрать категорию',
  'choose_language': 'Выбрать язык',
  'filtering_channel': 'Фильтровать каналы',
  'filtering_channel_by': 'Фильтровать по',
  'by_category': 'по категории',
  'by_language': 'по языку',
  'by_category_v2': 'категории',
  'by_language_v2': 'языку',
  'language': 'язык',
  'watch_channel': 'Смотреть канал',
  'watch': 'Смотреть',
  'tv_guide': 'ТВ-гид',
  'jump_to_time': 'Вернуться к началу',
  'volume': 'Громкость',
  'switch_channel': 'Переключение каналов',
  'switch_language': 'Смена языка',
  'anything_male': 'Любой',
  'anything_female': 'Любая',
  'of': 'из',
  'channels': 'каналы',
  'languages': 'языки',

  'not_available_channels': 'Нет доступных каналов.',
  'not_available_content': 'Контент заблокирован к просмотру. Обратитесь на ресепшен.',
  'list_is_empty': 'Список пуст',

  'listen_radio': 'Слушать радио',
  'filtering': 'Фильтровать',
  'filter': 'Фильтр',
  'all': 'Все',
  'enabled': 'включен',
  'by_genre': 'по жанру',
  'by_genre_v2': 'жанру',
  'all_genres': 'Все жанры',
  'radio_list': 'Список радио',
  'genres': 'Жанры',
  'radio_stop_playing': 'Остановить проигрывание',
  'downloading': 'Загрузка',
  'playing': 'Играет',
  'pause': 'Пауза',

  'day': 'день',
  'today': 'Сегодня',
  'tomorrow': 'Завтра',
  'monday': 'Понедельник',
  'tuesday': 'Вторник',
  'wednesday': 'Среда',
  'thursday': 'Четверг',
  'friday': 'Пятница',
  'saturday': 'Суббота',
  'sunday': 'Воскресенье',
  'wind': 'Ветер',
  'humidity': 'Влажность',
  'pressure': 'Давление',
  'cloudiness': 'Облачность',
  'wind_direct_full_n': 'Северный',
  'wind_direct_full_nne': 'Северно-восточный',
  'wind_direct_full_ene': 'Северно-восточный',
  'wind_direct_full_ne': 'Северно-восточный',

  'wind_direct_full_e': 'Восточный',
  'wind_direct_full_se': 'Юго-восточный',
  'wind_direct_full_ese': 'Юго-восточный',
  'wind_direct_full_sse': 'Юго-восточный',

  'wind_direct_full_s': 'Южный',
  'wind_direct_full_sw': 'Юго-западный',
  'wind_direct_full_ssw': 'Юго-западный',
  'wind_direct_full_wsw': 'Юго-Западный',

  'wind_direct_full_w': 'Западный',
  'wind_direct_full_nw': 'Северо-западный',
  'wind_direct_full_nnw': 'Северо-западный',
  'wind_direct_full_wnw': 'Северо-западный',

  'wind_direct_n': 'С',
  'wind_direct_ne': 'С-В',
  'wind_direct_nne': 'С-В',
  'wind_direct_ene': 'С-В',

  'wind_direct_e': 'В',
  'wind_direct_se': 'Ю-В',
  'wind_direct_sse': 'Ю-В',
  'wind_direct_ese': 'Ю-В',

  'wind_direct_s': 'Ю',
  'wind_direct_sw': 'Ю-З',
  'wind_direct_wsw': 'Ю-З',
  'wind_direct_ssw': 'Ю-З',

  'wind_direct_w': 'З',
  'wind_direct_nw': 'С-З',
  'wind_direct_nnw': 'С-З',
  'wind_direct_wnw': 'С-З',

  'metr_per_second': 'м/с',
  'miles_per_hour': 'миль/ч',
  'km_per_hour': 'км/ч',
  'pressure_dimension': 'мм',
  'pressure_dimension_inhg': 'in',
  'january': 'Январь',
  'february': 'Февраль',
  'march': 'Март',
  'april': 'Апрель',
  'may': 'Май',
  'june': 'Июнь',
  'july': 'Июль',
  'august': 'Август',
  'september': 'Сентябрь',
  'october': 'Октябрь',
  'november': 'Ноябрь',
  'december': 'Декабрь',
  'january_short': 'Янв',
  'february_short': 'Фев',
  'march_short': 'Мар',
  'april_short': 'Апр',
  'may_short': 'Май',
  'june_short': 'Июн',
  'july_short': 'Июл',
  'august_short': 'Авг',
  'september_short': 'Сен',
  'october_short': 'Окт',
  'november_short': 'Ноя',
  'december_short': 'Дек',
  'change_location': 'Сменить местоположение',
  'change_quantity': 'Изменить количество',
  'icon-light-rain': 'легкий дождь',
  'icon-clear-sky': 'солнечно',
  'icon-broken-clouds': 'облачно с прояснениями',
  'icon-few-clouds': 'малооблачно',
  'icon-mist': 'туман',
  'icon-rain': 'дождь',
  'icon-scattered-clouds': 'рассеянные облака',
  'icon-shower-rain': 'проливной дождь',
  'icon-snow': 'снег',
  'icon-thunderstorm': 'шторм',
  'select_btn': 'Выбрать',

  'sleep_timer': 'Sleep timer',
  'sleep_timer_will_powered_of': 'Телевизор будет выключен через:',
  'continue_watching_tv': 'Продолжить смотреть',
  'minutes_short': 'мин',
  'in': 'через',

  'select_time_date': 'Выберите время и дату',
  'change_time': 'Изменить время',
  'wakeup_set_to': 'Ваш будильник установлен на',
  'wakeup_cancelled': 'Будильник отменен',
  'just_wakeup': 'Будильник',
  'cancel': 'Отменить',

  'mod_title': 'Жанры',
  'mod_number': 'No.',
  'mod_title_audio': 'Title',
  'mod_artist': 'Artist',
  'mod_duration': 'Duration',

  'admission_to_adult': 'Категия для взрослых',
  'confirm_your_age':
    '<span class="ui-icon-18plus"></span>Эта категория содержит взрослый контент!<br /> Для продолжнения подтвердите свой возраст.',
  'im_an_adult': 'Мне больше 18 лет, войти',
  'im_a_child': 'Мне меньше 18 лет, назад',
  'buying_movie': 'Вы покупаете фильм',
  'confirm_sum':
    '<span class="custom_dialog_text_confirm">Для подтвреждения покупки,<br> введите сумму и нажмите ввод</span>',
  'confirm_pin':
    '<span class="custom_dialog_text_confirm">Для подтверждения покупки,<br> введите пинкод и нажмите ввод</span>',
  'confirm_room':
    '<span class="custom_dialog_text_confirm">Для подтверждения покупки,<br> введите номер комнаты и нажмите ввод</span>',

  'viewbill_pay': 'Оплатить',
  'express_checkout_failed':
    '<span class="custom_dialog_text_confirm">Что-то пошло не так,<br> обратитесь на ресепшен</span>',
  'express_checkout_retry':
    '<span class="custom_dialog_text_confirm">Что-то пошло не так,<br> попробуйте еще раз</span>',
  'express_checkout_success':
    '<span class="custom_dialog_text_confirm">Успешно!<br> Для получения чека обратитесь на ресепшен</span>',

  'guest_name': 'гость',
  'welcome_guest_name': 'Гость',
  'screen_sharing': 'Screen Sharing',

  'not_registered': 'Вы не зарегистрированы, <br> пожалуйста обратитесь на ресепшен',

  'next_programme': 'Далее',

  'product_added_header': 'Товар добавлен',
  'product_added_text': 'Вы можете добавить другие товары<br /> или перейти в корзину для завершения заказа',
  'delivery_time_header': 'Время доставки',
  'success_product_header': 'Ваш заказ уже в пути',
  'success_product_text':
    'Спасибо за заказ! <br />Вы можете посмотреть статус вашего заказа <br /> или отменить его в разделе Мои Заказы',
  'success_service_header': 'Запрос отправлен',
  'success_service_text':
    'Спасибо за заказ! <br />Вы можете посмотреть статус вашего заказа <br /> или отменить его в разделе Мои Заказы',
  'confirmation_page_header': 'Финальное подтверждение',
  'confirmation_page_text': 'Пожалуйста подтвердите заказ, введя запрошенные <br />ниже данные',
  'confirmation_page_text_tooltip': 'Обратите внимание, что сумма заказа будет начислена на ваш счет ',
  'confirmation_page_room_number': 'Ваш номер комнаты:',
  'confirmation_page_pin_code': 'ПИН код:',
  'confirmation_page_text_error': 'Данные не верны. Пожалуйста попробуйте еще раз или обратитесь на ресепшен',
  'approximate_time': 'Примерное время ожидания',
  'back_to_menu': 'Главное Меню',
  'my_orders': 'Мои заказы',
  'your_order': 'Ваш заказ',

  'und': 'Неопределенный',

  'track': 'трек',
  'nice_day': 'Хорошего дня,<br /> {username}!',

  'night': 'ночь',

  'dooreye_ask_title': 'Дверной Глазок',
  'dooreye_ask_text': 'Привет! У Вас посетитель.',
  'dooreye_ask_confirm': 'Показать',
  'dooreye_ask_cancel': 'Отмена',
  'dooreye_show_error': 'Проверьте Дверной глазок и видеосигнал',

  'airstream_fullscreen': 'На весь экран',
  'airstream_timeout_text': 'Вы всё ещё смотрите?<br>Через {timer} сек сессия будет прервана.',
  'airstream_title': 'AirPlay',
  'airstream_text': 'Просматривайте свой контент с iOS устройств используя AirPlay',
  'airstream_instruction_title': 'КАК НАЧАТЬ?',
  'airstream_instruction_text':
    '<ol><li>Выберите WiFi сеть <div id="airstream_wifi_name"></div></li><li id="airstream_qrauth">Отсканируйте QR-код камерой вашего смартфона<br></li><li>Выберите этот AppleTV: <div id="airstream_device_name"></div></li></ol>',
  'chromestream_text': 'Просматривайте свой контент с устройств используя ChromeCast',
  'chromestream_instruction_title': 'КАК НАЧАТЬ?',
  'chromestream_instruction_text':
    '<ol><li>Выберите WiFi сеть <div id="chromestream_wifi_name"></div></li><li id="chromestream_qrauth">Отсканируйте QR-код камерой вашего смартфона<br></li><li>Выберите этот ChromeCast: <div id="chromestream_device_name"></div></li></ol>',

  'tv_switch_off_info': 'ТВ выключится через {{data}} минут',

  'read': 'Читать',

  'yandex_station_notyet': 'Колонка ещё не активирована',
  'yandex_station_continue': 'Продолжить',

  'auto_poweroff_timeout_text': 'Вы ещё тут?<br>ТВ будет выключен через {timer} секунд',
  'fullscreen_language_btn': 'Language',

  'googlecast_connect_description':
    'Подключите ваше устройство к этому телевизору, чтобы транслировать контент в любое время во время вашего проживания. Ваше устройство останется подключенным до выезда.',
  'googlecast_settings_description':
    'Подключаясь, вы соглашаетесь с Условиями использования Google. Google собирает данные об использовании и отчеты о сбоях для улучшения Cast. Вы можете отключить это, а также ознакомиться с условиями и Политикой конфиденциальности Google в настройках Cast.',
  'googlecast_settings_button': 'Настройки Cast',
  'googlecast_qr_code_text': 'На вашем мобильном устройстве отсканируйте этот QR-код, чтобы начать',
  'googlecast_connect_without_qr': 'Подключиться без QR-кода',
  'googlecast_scan_qr_instead': 'Отсканировать QR-код вместо этого',
  'googlecast_help_text': 'По вопросам или для устранения неполадок, пожалуйста, обратитесь на ресепшен отеля.',
  'googlecast_step1_connect_wifi': 'Подключите ваше другое устройство к Wi-Fi',
  'googlecast_step2_password': 'Пароль',
  'googlecast_step2_visit_website': 'Сканируйте QR код или перейдите на ',
  'googlecast_step2_scan_qr_cdoe': 'Сканируйте QR код',
  'googlecast_step3_enter_room_pin': 'Введите номер комнаты и PIN-код',
  'googlecast_ready_to_cast': 'Вы готовы <br>начать кастинг',
  'googlecast_on_your_other_device': 'На вашем другом девайсе',
  'googlecast_open_your_favorite_app': 'Откройте ваше любимое приложение',
  'googlecast_tap_google_cast': 'Нажмите Google Cast',
  'googlecast_in_the_list': 'в списке',
  'done': 'Готово',
};
